import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["match", "score", "explanation"]
  static values = {
    matches: Array
  }

  connect() {
    this.initializeAnimation()
  }

  initializeAnimation() {
    // Warte auf das Ende der Turbo-Stream-Aktualisierung
    document.addEventListener("turbo:render", () => {
      this.animateMatches()
    })
  }

  animateMatches() {
    if (!this.hasMatchTargets) return

    // Initiale Animation für jeden Match
    this.matchTargets.forEach((match, index) => {
      match.style.opacity = "0"
      match.style.transform = "translateY(20px)"
      
      // Staggered Animation für die Matches
      setTimeout(() => {
        match.animate([
          { opacity: 0, transform: 'translateY(20px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], {
          duration: 500,
          easing: 'ease-out',
          fill: 'forwards'
        })
      }, index * 100)
    })

    // Score-Animation
    this.scoreTargets.forEach(score => {
      const value = parseInt(score.dataset.score)
      this.animateScore(score, value)
    })
  }

  animateScore(element, targetValue) {
    let currentValue = 0
    const duration = 1500
    const startTime = performance.now()

    const updateScore = (currentTime) => {
      const elapsed = currentTime - startTime
      const progress = Math.min(elapsed / duration, 1)

      currentValue = Math.floor(progress * targetValue)
      element.textContent = `${currentValue}%`

      if (progress < 1) {
        requestAnimationFrame(updateScore)
      }
    }

    requestAnimationFrame(updateScore)
  }

  // Erklärende Animation für die Match-Gründe
  animateExplanation(element) {
    const text = element.textContent
    element.textContent = ""
    
    let i = 0
    const typeWriter = () => {
      if (i < text.length) {
        element.textContent += text.charAt(i)
        i++
        setTimeout(typeWriter, 30)
      }
    }
    
    typeWriter()
  }
} 